import ControlledField from '../../ControlledField';
import FormNote from '../../FormNote';
import FormRadioGroup from '../../FormRadioGroup';
import { type FormCustomQuestionProps } from '../types';

const YesNoQuestion = ({ name, label, helpText, isRequired }: FormCustomQuestionProps) => (
  <ControlledField name={name}>
    <div>
      <ControlledField.Label isRequired={isRequired}>{label}</ControlledField.Label>
      {helpText && <FormNote>{helpText}</FormNote>}
    </div>
    <ControlledField.Control
      as={FormRadioGroup}
      options={[
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ]}
    />
    <ControlledField.ErrorMessage />
  </ControlledField>
);

export default YesNoQuestion;
